export default "__VITE_ASSET__waenw4cX__"